import { AxiosResponse } from "axios";
import {
  IPRRes,
  IReportErrorReq,
  ISearchPRParamsReq,
  PRStatus,
} from "../models/print.request.models";
import {
  downloadAsync,
  getAsync,
  postAsync,
  postDownloadFileAsync,
  putAsync,
} from "../utils/http-client";

export const searchPR = (
  params: ISearchPRParamsReq
): Promise<AxiosResponse<IPRRes[]>> => {
  const url = `manage-design/api/pr/search`;

  return getAsync(url, params);
};

export const getNumberOfMeters = (
  params: ISearchPRParamsReq
): Promise<AxiosResponse<number>> => {
  const url = `manage-design/api/pr/get-number-of-meters`;

  return getAsync(url, params);
};

export const getPR = (id: number): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/${id}`;

  return getAsync(url);
};

export const getHangtag = (id: number): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/${id}/download-hangtag`;

  return downloadAsync(url);
};

export const getCustomLabel = (id: number): Promise<AxiosResponse<string>> => {
  const url = `manage-design/api/pr/${id}/custom-label`;
  return getAsync(url);
};

export const getTFLink = (id: number): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/${id}/download-tf`;

  return downloadAsync(url);
};

export const getPullfile = (): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/charted/pull-file`;

  return getAsync(url);
};

export const postGenerateHangtag = (
  id: number
): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/${id}/generate-hangtag`;

  return postAsync(url, {});
};

export const putUpdateStatus = (
  params: number[],
  status: PRStatus
): Promise<AxiosResponse<any>> => {

  const url = `manage-design/api/pr/update-status?status=${status}`;

  return putAsync(url, params);
};

export const putUpdateSize = (
  params: number[],
  sizeName: string
): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/update-size?id=${params[0]}&sizeName=${sizeName}`;

  return putAsync(url);
};

export const applyPrintSlip = (printRequestIds: number[], printSlipId: string): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/apply-print-slip`;
  return postAsync(url, { printRequestIds, printSlipId });
};

export const removePrintSlip = (printRequestIds: number[], printSlipId: string): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/remove-print-slip`;
  return postAsync(url, { printRequestIds, printSlipId });
};

export const postRegenerateHangtag = (
  params: number[]
): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/regenerate-hangtag`;

  return postDownloadFileAsync(url, params);
};

export const putMarkPRAsShipReady = (
  id: string | number
): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/${id}/ship-ready`;

  return putAsync(url);
};
export const postReportError = (
  params: IReportErrorReq
): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/report-error`;

  return postAsync(url, params);
};
export const addPRComment = (
  id: string | number,
  comment: string
): Promise<AxiosResponse<any>> => {
  const url = `manage-design/api/pr/comment`;

  return postAsync(url, {id, comment});
};
